import {PaperCard} from '../../1elements'
import AssignUser from './AssignUser'

const GroupCreationFormCard3 = ({users, setUsers, showError, owner}) => {
    return (
        <PaperCard>
            <AssignUser users={users} setUsers={setUsers} owner={owner} showError={showError} />
        </PaperCard>
    )
}

export default GroupCreationFormCard3
